import React, { useState } from "react";
import { questsApi } from "../../api/quests.api";
import { QuestDto } from "../../dto/quest.dto";
import { useUser } from "../../hooks/useUser";
import { useI18n } from "../../i18n/I18nProvider";
import { BASE_TRACKER_URL } from "../../utils/constants";
import ProgressBar from "../progress/ProgressBar";
import { ClaimButton } from "../ui";

interface QuestCardProps {
  quest: QuestDto;
}

const QuestCard: React.FC<QuestCardProps> = ({ quest }) => {
  const isCompleted = quest.articleCount === quest.validatedArticleCount;
  return isCompleted ? (
    <CompletedQuestCard quest={quest} />
  ) : (
    <ProgressingQuestCard quest={quest} />
  );
};

const CompletedQuestCard: React.FC<QuestCardProps> = ({
  quest: initialQuest,
}) => {
  const { t } = useI18n();
  const [quest, setQuest] = useState(initialQuest);
  const { addPoints } = useUser();

  const handleClaimReward = async () => {
    if (quest.isClaimed) return;
    questsApi
      .claimReward(quest.id)
      .then(() => {
        setQuest({ ...quest, isClaimed: true });
        addPoints(quest.points);
      })
      .catch((error) => {
        console.error("Error claiming reward:", error);
      });
  };

  return (
    <div className="flex w-full" style={{ minHeight: "100px" }}>
      <img
        src={`${BASE_TRACKER_URL}/trophy/win.svg`}
        alt="win trophy"
        style={{ position: "absolute", zIndex: 10 }}
      />
      <div
        className="flex items-start bg rounded gap-1"
        style={{
          flexDirection: "column",
          width: "85%",
          minHeight: "100%",
          position: "relative",
          marginLeft: "auto",
        }}
      >
        <div
          className="flex flex-col text-white"
          style={{
            marginTop: "0.25rem",
            marginBottom: "0.25rem",
            alignItems: "center",
            fontSize: "0.75rem",
            fontWeight: 400,
            width: "100%",
            paddingLeft: "3.25rem",
            paddingRight: "0.25rem",
            lineHeight: "normal",
          }}
        >
          {t("QuestCompletedDescription", { quest: quest.title })}
        </div>
        <ClaimButton
          onClick={handleClaimReward}
          isClaimed={quest.isClaimed}
          points={quest.points}
        />
      </div>
    </div>
  );
};

const ProgressingQuestCard: React.FC<QuestCardProps> = ({ quest }) => {
  const { t } = useI18n();

  return (
    <div
      className="flex gap-4 items-start p-3 bg rounded"
      style={{ position: "relative" }}
    >
      <div
        className="w-14 h-14 overflow-hidden rounded-lg"
        style={{
          minWidth: "3.5rem",
          minHeight: "3.5rem",
          position: "relative",
        }}
      >
        <img
          src={quest.image}
          className="object-cover w-full h-full"
          alt="quest"
        />
        <div
          style={{
            position: "absolute",
            bottom: 0,
            right: 0,
            background: "var(--color-primary)",
            color: "var(--color-white)",
            borderTopLeftRadius: "0.5rem",
            padding: "0rem 0.3rem",
            fontWeight: 600,
            fontSize: 10,
            zIndex: 10,
            letterSpacing: 0,
            display: "inline-block",
          }}
        >
          {quest.points}
        </div>
      </div>
      <div
        className="flex h-full"
        style={{
          flexDirection: "column",
          alignSelf: "flex-start",
          justifyContent: "space-between",
          minHeight: "3.5rem",
          width: "80%",
        }}
      >
        <div>
          <div
            className="text-white"
            style={{
              fontSize: "0.6rem",
              fontWeight: 700,
              margin: 0,
              padding: 0,
              alignSelf: "flex-start",
            }}
          >
            {quest.title}
          </div>
          <div
            className="flex"
            style={{
              gap: "0.5rem",
              alignItems: "center",
              margin: 0,
              padding: 0,
              marginTop: "0.35rem",
            }}
          >
            <div
              className="text-white"
              style={{ fontSize: "0.5rem", margin: 0, padding: 0 }}
            >
              {t("ReadAllArticles")}
            </div>
          </div>
        </div>
        <div style={{}}>
          <ProgressBar
            value={quest.validatedArticleCount}
            max={quest.articleCount}
          />
        </div>
      </div>
    </div>
  );
};

export default QuestCard;
